import React, { useEffect, useState } from "react";
import { DEFAULT_USER_IMG_PATH } from "../../Utils/constants";

const IMGATOM = (props) => {

    const [src, setsrc] = useState()

    useEffect(() => {
        setsrc(props.url || DEFAULT_USER_IMG_PATH);
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const handleError = () => {
        setsrc(DEFAULT_USER_IMG_PATH)
    }

    return (
        <>
            <img
                {...props}
                alt={props.alt}
                src={src}
                onError={handleError}
            />
        </>
    );
}

export default IMGATOM